import { Theme } from "@mui/system";
import Radiobutton from "./Radiobutton";
import Checkbox from "./Checkbox";
import Button from "./Button";
import Link from "./Link";
import TextField from "./TextField";
import ListItemIcon from "./ListItemIcon";
import Table from "./Table";

const componentsOverride = (theme: Theme) =>
  Object.assign(
    Button(theme),
    Link(),
    Radiobutton(theme),
    Checkbox(theme),
    TextField(theme),
    ListItemIcon(),
    Table()
  );

export default componentsOverride;
